<template>
  <div>
    <com-search :columns="searchColumn" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleCreated" v-if="!typeOfView">添加小区</el-button>
      </template>
    </com-search>
  </div>
</template>

<script>
export default {
  props: {
    typeOfView: {
      type: String,
      default: ''
    }
  },
  watch: {
    typeOfView: {
      handler(val) {

      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      searchColumn: [
        {
          label: '小区名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '归属',
          prop: 'refBelongAgentName',
          type: 'input'
        },
        {
          label: '地区',
          prop: 'areaCodes',
          type: 'region'
        },
      ],
    }
  },
  methods: {
    handleSearch(val) {
      console.log('handleSearch11111 :>> ', val)
      this.$emit('search', val)
    },
    handleExport() {
      this.$emit('onExport')
    },

    handleCreated() {
      this.$emit('add')
    },
  }
}
</script>
